/**
 * Created by Administrator on 2018/4/12.
 */
export default {
  getFormatDate: () => {
    let date = new Date()
    let year = parseInt(date.getFullYear())
    let month = parseInt(date.getMonth()) + 1
    let day = parseInt(date.getDate())
    month = month < 10 ? ('0' + month) : month.toString()
    day = day < 10 ? ('0' + day) : day.toString()
    return year + '-' + month + '-' + day
  },

  toBoolean: (str) => {
    if (str === 'true') {
      return true
    } else {
      return false
    }
  },

  formatOrderState (state) {
    let str = ''
    switch (state) {
      case 10001:
        str = '预约审核中'
        break
      case 10002:
        str = '订单信息待确认'
        break
      case 10003:
        str = '合同待签署'
        break
      case 10004:
        str = '合同待打款'
        break
      case 10005:
        str = '打款资料确认中'
        break
      case 10006:
        str = '冷静期'
        break
      case 10007:
        str = '签约成功'
        break
      case 10008:
        str = '签约失败'
        break
      case 10009:
        str = '预约审核失败'
        break
      case 10010:
        str = '打款资料审核失败'
        break
      case 10011:
        str = '订单已取消'
        break
      case 10012:
        str = '撤销订单'
        break
      case 10013:
        str = '订单赎回'
        break
      case 10014:
        str = '合同待签署'
        break
      case 10015:
        str = '双录待审核'
        break
      case 10016:
        str = '双录审核失败'
        break
      case 10017:
        str = '追加确认中'
        break
      case 10018:
        str = '合同信息待审核'
        break
      case 10019:
        str = '合同信息审核失败'
        break
      case 10020:
        str = '追加审核不通过'
        break
      case 10021:
        str = '订单回访中'
        break
      case 10022:
        str = '合同待签署'
        break
      case 10023:
        str = '合同待签署'
        break
      default :
        str = ''
    }
    return str
  }
}



// WEBPACK FOOTER //
// ./src/common/js/my_util.js